import React from 'react'
import PageFooter from './PageFooter'
import PageHeaderEvent from './PageHeaderEvent'
import PageMain from './PageMain'

// headingRef: wer den Fokus nach einem Wechsel auf die Ueberschrift setzen
// will (useFocusHeading), reicht sein ref hier herein (#178).
const PageWrapper = ({
    displayFooter = false,
    className,
    headingRef = null,
    children
}) => {
    
    return (
        <div className={"jm-page" + (className ? ' ' + className : '')}>
            <PageMain 
                className="jm-ready"
                header={<PageHeaderEvent ref={headingRef} />}
                children={children}
                footer={displayFooter && <PageFooter />}
            />
        </div>
    )
}

export default PageWrapper